const initialState = {
    data:[],
    approvedata: [],
    reject: [],
    revoke: []

};

const AviewDoctorReducers = (state = initialState, action: any) => {
    switch (action.type) {
        case 'FETCH_DATA_SUCCESS':
            return { ...state, data: action.payload };
        case 'FETCH_Approve_SUCCESS':
            return { ...state, approvedata: action.payload };
        case 'FETCH_Reject_SUCCESS':
            return { ...state, reject: action.payload };
        case 'FETCH_Revoke_SUCCESS':
            return { ...state, revoke: action.payload };



        default:
            return state;
    }
};

export default AviewDoctorReducers;

